import { authService } from '../services/authServices';
import {
    AUTH_SIGNING,
    LOGIN,
    LOGIN_SUCCEED,
    LOGIN_FAILED,
    LOGOUT,

    SIGNUP,
    SIGNUP_SUCCEED,
    SIGNUP_FAILED,

    CHECK_EXIST,
    CHECK_FAILED,
    CHECK_SUCCEED,

    GET_USER_INFO,
    GET_USER_INFO_SUCCEED,
    GET_USER_INFO_FAILED,

    GET_RELEASE_DETAIL,
    GET_RELEASE_DETAIL_SUCCEED,
    GET_RELEASE_DETAIL_FAILED,
    SESSION_VALID,
    AUTH_SIGN_FINISHED,
} from '../constants';
import { history } from '../../utils/History';
import { alertActions } from './alertActions';
import { walletActions } from './walletActions';
import { isValidBtcAddress, isValidDogeAddress } from '../../utils/Common';
import { LogOut } from '../../utils/Sign';
import * as Contract from "../../config/Contract.json";
export const authActions = {
    checkUser,
    signUp,
    logIn,
    logOut,
    authSigning,
    getUserInfo,
    getReleaseDetail,
    checkSession,
    saveWalletConfig,
    authSignFinished,
    dappDisconnect,
    connectWallet
}

function authSigning() {
    return dispatch => {
       dispatch(authSigning(true))
    }
    function authSigning(loading) {return { type: AUTH_SIGNING, loading }}
}

function authSignFinished() {
    return dispatch => {
       dispatch(authSignFinished(true))
    }
    function authSignFinished(loading) {return { type: AUTH_SIGN_FINISHED, loading }}
}


function checkUser(address) {
    return dispatch => {
        dispatch(request({ address }));
        authService.checkUser(address)
            .then(
                res => {
                    dispatch(success(!res.data));
                },
                error => {
                    if (error.message === 'This username has been used by another account.') {
                        dispatch(success(true));
                    } else {
                        dispatch(failure(error.toString()));
                        dispatch(alertActions.error(error.toString()));
                    }
                }
            );
    };

    function request(address) { return { type: CHECK_EXIST, address } }
    function success(registered) { return { type: CHECK_SUCCEED, registered } }
    function failure(error) { return { type: CHECK_FAILED, error } }
}

function connectWallet() {

}

function signUp(payload, type) {
    console.log('signing up : ', payload)
    return dispatch => {
        dispatch(request());
        authService.signUp(payload, type)
            .then(
                res => {
                    if (res) {
                        dispatch(success(res.success));
                        dispatch(logIn(payload.btcPersonalSign, type))
                    }
                },
                error => {
                    if (error.data === 'Wrong net work') {
                        dispatch(failure('wrongNetwork'));
                    } else {
                        dispatch(failure(error.data));
                    }
                }
            );
    };

    function request() { return { type: SIGNUP } }
    function success(registered) { return { type: SIGNUP_SUCCEED, registered } }
    function failure(message) { return { type: SIGNUP_FAILED, message } }

}

function logIn(payload, type) {
    console.log('logging in : ', payload, type)
    return dispatch => {
        dispatch(request());
        authService.logIn(payload, type)
            .then(
                res => {
                    if (res.success) {
                        localStorage.setItem(
                            type === 'DOGE' || type === 'BTC' ? `xyzToken:${payload.address}_${payload.chainId}_${payload.network}` : `xyzToken:${payload.pubKeyAddress}_${payload.chainId}_${payload.networkId}`,
                            res.data
                          );
            
                    }
                    res.payload = payload
                    dispatch(success(res));
                },
                error => {
                    if (error.data === 'Wrong net work') {
                        dispatch(failure('wrongNetwork'));
                    } else {
                        dispatch(failure(error.data));
                    }
                }
            );
    };

    function request(payload) { return { type: LOGIN, payload } }
    function success(data) { return { type: LOGIN_SUCCEED, data } }
    function failure(message) { return { type: LOGIN_FAILED, message } }
}

function logOut(dappAddress, _chainIdNumber, network) {
    const temp = localStorage.getItem(
        `xyzToken:${dappAddress}_${_chainIdNumber}_${network}`
      );
    if (temp !== null && temp !== undefined) {
    localStorage.removeItem(
        `xyzToken:${dappAddress}_${_chainIdNumber}_${network}`
    );
    }
    return dispatch => {
        dispatch(request());

    };
    function request() { return { type: LOGOUT } }
}

function dappDisconnect(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected) {
    return dispatch => {
        localStorage.setItem('walletDisconnected', 'true');
        localStorage.removeItem('currentWallet');
        localStorage.setItem('evmWalletConfig', JSON.stringify(null))
        localStorage.setItem('btcWalletConfig', JSON.stringify(null))    
        localStorage.setItem('dogeWalletConfig', JSON.stringify(null))    
        LogOut(dispatch, address, chainId, network, setAddress, setChainId, setNetwork, setPublicKey, setDappConnected, setWallet, setStartWatch, setWalletDisconnected)
    }
}

function getUserInfo(token) {
    return dispatch => {
        dispatch(request());
        authService.getUserInfo(token)
            .then(
                res => {
                    dispatch(success(res.data));
                },
                error => {
                    dispatch(failure(error.data));
                }
            );
    };

    function request(payload) { return { type: GET_USER_INFO, payload } }
    function success(data) { return { type: GET_USER_INFO_SUCCEED, data } }
    function failure(message) { return { type: GET_USER_INFO_FAILED, message } }
}

function getReleaseDetail() {
    return dispatch => {
        dispatch(request());
        authService.getReleaseDetail()
            .then(
                res => {
                    dispatch(success(res.data));
                },
                error => {
                    dispatch(failure(error.data));
                }
            );
    };

    function request(payload) { return { type: GET_RELEASE_DETAIL, payload } }
    function success(data) { return { type: GET_RELEASE_DETAIL_SUCCEED, data } }
    function failure(message) { return { type: GET_RELEASE_DETAIL_FAILED, message } }
}

function checkSession(payload) {
    return dispatch => {
        const token = localStorage.getItem(
            `xyzToken:${payload.address}_${payload.chainId}_${payload.network}`
          );
          console.log('checking session !!!!!!!!!!: ', token)
          if (token !== undefined && token !== null) {
            console.log('resume session !')
            setTimeout(() => {
              let data2 = {
                  loggedIn: true,
                  loggingIn: false,
                  registered: true,
                  token,  
                }
                dispatch(sessionValid(data2))
                dispatch(walletActions.getUserCapital(token))
            }, 500)
          }
    }


    function sessionValid(data) { return { type: SESSION_VALID, data } }

    
}

function saveWalletConfig(payload) {
    return dispatch => {
        /** Save walletConfig */
        let account = {
            address: payload.address,
            chainId: payload.chain.toString(),
            network: payload.network,
            unlockTime: Date.now(),
            wallet: payload.wallet,
            publicKey: payload.publicKey
        }
        console.log('saving: ', account)
        localStorage.setItem(isValidBtcAddress(payload.address) ? 'btcWalletConfig' : isValidDogeAddress(payload.address) ? 'dogeWalletConfig' : 'evmWalletConfig', JSON.stringify(account))
    }
}